import { GetterTree } from 'vuex';
import { UserModel } from '@descomplica/dex-models';
import { UserState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<UserState, RootState> = {
  currentUser: (state, userGetters) => {
    const user = state.token ? state.user : undefined;

    return user ? new UserModel(user, userGetters) : {};
  },
  isUserLogged: (state) => {
    return !!state.token;
  },
  teacherByUserId:
    (state, userGetters) =>
    (userId: number): UserModel | undefined => {
      const user = state.users[userId.toString()];
      return user ? new UserModel(user, userGetters) : undefined;
    },
  userById:
    (state, userGetters) =>
    (userId: number): UserModel | undefined => {
      const user = state.users[userId.toString()];
      if (!user) {
        return undefined;
      }
      return new UserModel(user, userGetters);
    },
  shouldDisplaySocialMetaverse: (state) => {
    return state.shouldDisplaySocialMetaverse;
  },
  showPostgradAssessmentsCard: (state) => {
    return state.showPostgradAssessmentsCard;
  },
  showPostgradTCCAssessment: (state) => {
    return state.showPostgradTCCAssessment;
  },
  showDueDateWarning: (state) => {
    return state.showDueDateWarning;
  },
  canViewTermsOfUse: (state) => {
    return state.canViewTermsOfUse;
  },
  currentCourse: (state) => {
    return state.currentCourse;
  },
  isUndergraduateCourse(state, userGetters) {
    return userGetters.currentCourse?.descomplicaCategorySlug === 'graduacao' || false;
  },
  isPostgraduateCourse(state, userGetters) {
    return userGetters.currentCourse?.descomplicaCategorySlug === 'pos' || false;
  },
  canViewPostgradStudyPlanning(state, userGetters) {
    return userGetters.isPostgraduateCourse && state.canViewPostgradStudyPlanning;
  },
  shouldDisplayPublicVideoNotes: (state) => {
    return state.shouldDisplayPublicVideoNotes;
  },
  canViewUndergradClassroomsGrades: (state) => {
    return state.canViewUndergradClassroomsGrades;
  },
  canViewPostgradCertificate: (state) => {
    return state.canViewPostgradCertificate;
  },
  shouldGetTrial: (state) => {
    return state.shouldGetTrial;
  },
  canViewPostgradContractExtensionButton: (state) => {
    return state.canViewPostgradContractExtensionButton;
  },
  canViewPostgradStudentDocuments: (state) => {
    return state.canViewPostgradStudentDocuments;
  },
  shouldShowEqualWebWidget: (state) => {
    return state.shouldShowEqualWebWidget;
  },
  shouldDisplayPeriodsRenamed: (state) => {
    return state.shouldDisplayPeriodsRenamed;
  },
  gradeActivitiesViaAi: (state) => {
    return state.gradeActivitiesViaAi;
  },
};

export default getters;
